module.exports = __webpack_public_path__ + "images/mdj/members/resume/resume_end_screen/icon-foreign-ebc49d5e05ffc0fecd7613a2313dea4a.png";